//
import { mapActions } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'

//
import PurchaseInvoiceModel from '@/models/Purchase/PchPurchaseInvoice'
import fields from './fields'

//
export default {
    name: 'purchase-invoice-update',
    components: {
        ModelForm,
    },
    computed: {
        /**
         * @description
         */
        formProps() {
            return {
                editable: false,
                fields: fields({ invoice_number: this.invoiceNumber }),
                loading: this.busy,
            }
        },
    },
    data() {
        return {
            busy: false,
            formData: {},
            invoiceNumber: 0,
        }
    },
    methods: {
        /**
         * @description
         */
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        /**
         * @description
         */
        fetch() {
            PurchaseInvoiceModel.modeler()
                .find(this.$route.params.id)
                .then(this.setFormData)
        },

        /**
         * @description
         */
        reset() {
            this.fetch()
            this.toggleBusy()
        },

        /**
         * @description
         */
        setFormData(model) {
            model.pch_purchase_order_has_invoice_numbers = this.formatPchOrderDetails(
                model
            )
            this.busy = false
            this.formData = model.reset()
            console.log('form data: ', this.formData)
            this.invoiceNumber = model.invoice_number
        },

        /**
         * @description
         */
        toggleBusy() {
            this.busy = !this.busy
        },

        /**
         *
         */
        formatPchOrderDetails: function(data) {
            return data.pch_purchase_order_has_invoice_numbers.map(r => {
                r.g_originator_user_full_name =
                    r.pch_purchase_order.g_originator_user.hr_employee.names +
                    ' ' +
                    r.pch_purchase_order.g_originator_user.hr_employee
                        .last_name1 +
                    ' ' +
                    r.pch_purchase_order.g_originator_user.hr_employee
                        .last_name2
                r.pch_provider_alias_name = data.pch_provider.alias_name
                r.created_at = r.pch_purchase_order.created_at
                r.authorization_date = r.pch_purchase_order.authorization_date
                r.pch_purchase_order_state_name = this.setStateName(
                    r.pch_purchase_order.pch_purchase_order_state_id
                )
                r.total = r.pch_purchase_order.total
                return r
            })
        },

        /**
         *
         */
        setStateName: function(status_id) {
            switch (status_id) {
                case 1:
                    return 'Creada'
                case 2:
                    return 'Rechazada'
                case 3:
                    return 'Autorizada'
                case 4:
                    return 'Enviada'
                case 5:
                    return 'Cerrada Parcialmente'
                case 6:
                    return 'Cerrada'
            }
        },
    },
    beforeMount() {
        this.setTitleTopBar('Datos de factura de compra')
    },
    mounted() {
        this.reset()
    },
}
